import { useDropzone } from "react-dropzone";
import React, { useEffect, useState } from "react";
import { LuImagePlus } from "react-icons/lu";

import "./dropzone-input.scss";

function DropzoneInput(props) {
  const [files, setFiles] = useState([]);

  const handleDrop = (acceptedFiles) => {
    const fixedFiles = acceptedFiles.map((file) => {
      if (!file.type) {
        if (file.name.endsWith(".gltf")) {
          file = new File([file], file.name, { type: "model/gltf" });
        }
      }

      return Object.assign(file, {
        preview: URL.createObjectURL(file),
      });
    });

    setFiles(fixedFiles);
    props.updateSelectedServiceFiles(fixedFiles);
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: props.type,
    onDrop: handleDrop,
    multiple: props.mulitple ? props.multiple : true,
  });

  useEffect(
    () => () => {
      files.forEach((file) => URL.revokeObjectURL(file.preview));
    },
    [files],
  );
  return (
    <section className="dropzone-input">
      <div className="" {...getRootProps({ className: "dropzone" })}>
        <input {...getInputProps()} />

        <div className="content">
          <LuImagePlus size="8%" color="#6B747C" />

          {files.length > 0
            ? files[0].name
            : props.value
              ? props.value?.name || props.value?.split("/").pop()
              : "Drag 'n' drop some files here, or click to select files"}
        </div>
      </div>
    </section>
  );
}

export default DropzoneInput;
